import { handicapLabel, hasHandicap } from '../utils/handicap';

export const HeaderHandicap = ({ value, rounds = null, status, onClick }) => {
  const established = hasHandicap(value);
  const description = status === 'error' ? 'Handicap unavailable. Open statistics to try again.'
    : status === 'loading' ? 'Loading handicap'
      : established ? `Par Seeker handicap ${handicapLabel(value)}${rounds !== null ? `, ${rounds} rounds logged` : ''}`
        : 'Handicap not established';
  return <button type="button" data-testid="header-handicap" className="ps-header-handicap"
    onClick={onClick} title={description} aria-label={description} aria-busy={status === 'loading'}>
    <span data-testid="header-handicap-value" className="ps-header-handicap-value">
      {status === 'loading' && !established ? '…' : established ? handicapLabel(value) : '—'}
    </span>
    <span data-testid="header-handicap-label" className="ps-header-handicap-label">Handicap</span>
  </button>;
};